import { useEffect, useRef, useState } from 'react';

import { api } from '../api/endpoints';
import type { PersonCard } from '../api/types';
import { PersonCardView } from '../components/PersonCardView';

interface Props {
  onOpenPerson: (id: number) => void;
}

export function PeoplePage({ onOpenPerson }: Props) {
  const [query, setQuery] = useState('');
  const [people, setPeople] = useState<PersonCard[] | null>(null);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    // Дебаунс: иначе каждый набранный символ бьёт в API.
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setPeople(null);
      api
        .people(query.trim() || undefined)
        .then(setPeople)
        .catch(() => setPeople([]));
    }, 250);

    return () => window.clearTimeout(timer.current);
  }, [query]);

  return (
    <div className="screen">
      <h1 className="screen__title">Участники</h1>

      <input
        className="search"
        type="search"
        placeholder="Имя, бизнес, ниша, что ищет"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />

      {people === null ? (
        <div className="skeleton" />
      ) : people.length === 0 ? (
        <p className="muted">
          {query ? 'Никого не нашлось. Попробуйте другой запрос.' : 'Участников пока нет.'}
        </p>
      ) : (
        <div className="people">
          {people.map((person) => (
            <PersonCardView
              key={person.user_id}
              person={person}
              onOpen={onOpenPerson}
            />
          ))}
        </div>
      )}
    </div>
  );
}
